<template>
    <div class="app-utility-item app-notifications-dropdown dropdown">
	    <a @click="markAsRead" class="dropdown-toggle no-toggle-arrow" id="notifications-dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" title="Notifications">
		    <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
			<svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-bell icon" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2z"/>
                <path fill-rule="evenodd" d="M8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"/>
            </svg>
			<span class="icon-badge" v-if="unread > 0">{{ unread }}</span>
		</a><!--//dropdown-toggle-->

        <div class="dropdown-menu p-0" aria-labelledby="notifications-dropdown-toggle">
            <div class="dropdown-menu-header p-3">
                <h5 class="dropdown-menu-title mb-0">{{ __('notifications.title') }}</h5>
            </div><!--//dropdown-menu-title-->
            <div class="dropdown-menu-content">
                <div class="item p-3" v-for="(notification, index) in notifications" :key="index" v-bind:class="{'unread':(notification.read_at == null)}">
                    <div class="row gx-2 justify-content-between align-items-center">
                        <div class="col">
                            <div class="info">
                                <div class="desc">{{ notification.message }}</div>
                                <div class="meta">{{ notification.human_date_diff }}</div>
                            </div>
                        </div><!--//col-->
                    </div><!--//row-->
                </div>
            </div><!--//dropdown-menu-content-->

            <!-- <div class="dropdown-menu-footer p-2 text-center">
                <a href="notifications.html">View all</a>
            </div> -->

        </div><!--//dropdown-menu-->
    </div><!--//app-utility-item-->
</template>

<script>
export default {
    name: "notificationComponent",

    data () {
        return {
            notifications: [],
            ids: [],
            unread: 0
        }
    },

    created () {
        this.loadNotifications();

        this.interval = setInterval(function () {
            this.loadNotifications();
        }.bind(this), 30000);
    },

    methods: {

        loadNotifications: function (){
          axios.get('/notifications/get')
            .then(response => {
                this.notifications = response.data.notifications
                this.unread = response.data.unread
                this.notificationIds = response.data.ids
            })
        },

        markAsRead: function(){
            axios.post('/notifications/markasread', {ids: this.notificationIds})
                .then(response =>(
                    this.unread = 0,
                    this.loadNotifications()
                ))
        }
    }
}
</script>

<style scoped>

</style>
